import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { Group } from '@work4all/models/lib/Classes/Group.entity';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';
import {
  SalesOpportunitiesGroupPicker,
  SalesOpportunitiesGroupPickerProps,
} from '../filters/SalesOpportunitiesGroupPicker';

interface Props
  extends Omit<
    SalesOpportunitiesGroupPickerProps,
    'multiple' | 'value' | 'onChange'
  > {
  error?: string;
  value: Group | null;
  onChange: (group: Group | null) => void;
}

export const SalesOpportunitiesGroupPickerField = React.forwardRef<
  HTMLDivElement,
  Props
>((props, ref) => {
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  return (
    <EntityPickerPopover
      picker={
        <SalesOpportunitiesGroupPicker
          {...pickerProps}
          multiple={false}
          onChange={(groups) => {
            if (groups && groups.length > 0) {
              onChange(groups[0]);
            } else {
              onChange(null);
            }
          }}
        />
      }
    >
      <PickerTargetButton
        ref={ref}
        onClear={() => {
          onChange(null);
        }}
        label={t('COMMON.GROUP')}
        error={error}
        value={value?.name || ''}
      />
    </EntityPickerPopover>
  );
});
